<template>
  <el-card>
    <template #header>
      <content-header />
    </template>
    <el-row type="flex" justify="left">
      <lz-form ref="form" :get-data="getData" :submit="onSubmit" :form.sync="form" :errors.sync="errors" :edit-mode="editMode">
        <el-form-item label="用户名/手机号" required prop="username"
          ><el-input v-model="form.username" placeholder="用户名/手机号"
        /></el-form-item>
        <el-form-item label="密码" required prop="password"
          ><el-input v-model="form.password" placeholder="密码" show-password
        /></el-form-item>
        <!-- <el-form-item label="身份证" required prop="idcard_photo"></el-form-item> -->
        <el-form-item label="身份信息" required prop="real_name">
          <!-- <el-row :gutter="20"><file-picker v-model="form.idcard_photo" ext="jpg,gif,png,jpeg" /></el-row> -->
          <el-row :gutter="10">
            <el-col :span="5"><el-input v-model="form.real_name" placeholder="姓名"/></el-col>
            <el-col :span="6"><el-input v-model="form.idcard_no" placeholder="身份证"/></el-col>
            <el-col :span="12"><city-cascader ref="cityCascader" placeholder="所属区域" v-model="form.area_info"/></el-col>
          </el-row>
        </el-form-item>
        <el-form-item label="微信号" required prop="wechat"><el-input v-model="form.wechat" placeholder="微信号"/></el-form-item>
        <el-form-item label="代理级别" required prop="level_id">
          <el-select v-model="form.level_id" placeholder="请选择">
            <el-option v-for="item in level_options" :key="item.id" :label="item.level_name" :value="item.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="是否分配推荐奖金" required prop="allow_invite_rebate"
          ><el-switch v-model="form.allow_invite_rebate"
        /></el-form-item>
        <el-form-item label="上级代理" prop="parent_username"
          ><el-input v-model="form.parent_username" placeholder="上级代理手机号"
        /></el-form-item>
        <el-form-item label="安置关系" prop="posit_parent_username"
          ><el-alert title="如需安置在总部账号下，填administrator" type="warning" :closable="false"/><el-input
            v-model="form.posit_parent_username"
            placeholder="安置关系"
        /></el-form-item>
      </lz-form>
    </el-row>
  </el-card>
</template>

<script>
import LzForm from '@c/LzForm'
// import FilePicker from '@c/FilePicker'
import { storeUser, createUser } from '@/api/users'
import { getLevelList } from '@/api/user-levels'
import FormHelper from '@c/LzForm/FormHelper'
import CityCascader from '@c/CityCascader'

export default {
  name: 'Form',
  components: {
    LzForm,
    // FilePicker,
    CityCascader,
  },
  mixins: [FormHelper],
  data() {
    return {
      form: {
        username: '',
        mobile: '',
        password: '',
        real_name: '',
        idcard_no: '',
        // idcard_photo: '',
        wechat: '',
        level_id: '',
        area_info: [],
        province: '',
        province_code: 0,
        city: '',
        city_code: 0,
        district: '',
        district_code: 0,
        allow_invite_rebate: true,
        parent_username: '',
        posit_parent_username: '',
      },
      errors: {},
      level_options: [],
    }
  },

  created() {
    this.getUserLevel()
  },
  methods: {
    async getData() {
      let data
      if (!this.editMode) {
        ;({ data } = await createUser())
      }
    },
    async getUserLevel() {
      const { data } = await getLevelList({ register_level: 1 })
      this.level_options = data
    },

    async onSubmit() {
      if (this.editMode) {
        this.$message.error('类型异常')
        return
      }

      this.form.mobile = this.form.username
      if (this.form.area_info.length > 0) {
        const labels = this.$refs['cityCascader'].$refs['CityCascader'].inputValue
        const newLabels = labels.replace(/\s*/g, '')
        const cityLabels = newLabels.split('/')
        const area_info_code = this.form.area_info

        this.form.province = cityLabels[0]
        this.form.province_code = area_info_code[0]
        this.form.city = cityLabels[1]
        this.form.city_code = area_info_code[1]
        this.form.district = cityLabels[2]
        this.form.district_code = area_info_code[2]
      }

      const { data } = await storeUser(this.form)
      return true
    },
  },
}
</script>

<style scoped lang="scss"></style>
